import Next from "../images/Skills/nxt.js.png";
import ROR from "../images/Skills/ROR.png";
import MUI from "../images/Skills/MUI.png";

export const skills = [
  {
    title: "React",
    icon: "react",
    boxIcon: true,
  },
  {
    title: "Python",
    icon: "python",
    boxIcon: true,
  },
  {
    title: "JavaScript",
    icon: "javascript",
    boxIcon: true,
  },
  {
    title: "Next.js",
    icon: Next,
    boxIcon: false,
  },
  {
    title: "TypeScript",
    icon: "typescript",
    boxIcon: true,
  },
  {
    title: "Node.js",
    icon: "nodejs",
    boxIcon: true,
  },
  {
    title: "HTML5",
    icon: "html5",
    boxIcon: true,
  },
  {
    title: "CSS3",
    icon: "css3",
    boxIcon: true,
  },
  {
    title: "Tailwind CSS",
    icon: "tailwind-css",
    boxIcon: true,
  },
  {
    title: "MUI",
    icon: MUI,
    boxIcon: false,
  },
  {
    title: "Bootstrap",
    icon: "bootstrap",
    boxIcon: true,
  },
  {
    title: "Git",
    icon: "git",
    boxIcon: true,
  },
  {
    title: "GitHub",
    icon: "github",
    boxIcon: true,
  },
  {
    title: "Ruby on Rails",
    icon: ROR,
    boxIcon: false, 
  },
  {
    title: "MongoDB",
    icon: "mongodb",
    boxIcon: true,
  },
  {
    title: "AI Tools",
    icon: "brain",
    boxIcon: true,
  },
];
